import axios from "axios";
import authHeader from "../auth/auth-header";
import services from "@/config/services";
import Cookies from "js-cookie";

/**
 * Servizio statistiche PdC (Gestione PdC > Statistiche).
 *
 * Espone gli endpoint on-demand del backend ask_pratiche:
 *  - /management/pdc/stats/flussi          andamento flussi (richieste/ammesse/KO/esiti)
 *  - /management/pdc/stats/stato-pratiche  stato pratiche (pod / pod_statopratica)
 *  - /management/pdc/stats/errori          dettaglio causali di errore
 *  - /management/pdc/stats/pods            lista POD delle richieste inviate (stessi filtri)
 *  - /management/pdc/stats/pod/{code}      dettaglio storico di un singolo POD
 *
 * Parametri comuni (query string): { period: 'oggi'|'settimana'|'mese', tipo: 'tutti'|'sospensioni'|'riattivazioni', from, to }
 */
export default class GestionePdcStatsService {
  constructor() {
    this.baseUrl = `${services.ask_pratiche_api.url}`;

    axios.interceptors.request.use((req) => {
      req.headers["Authorization"] = authHeader();
      req.headers["Params"] =
        Cookies.get("google_access_token") || Cookies.get("ask_access_token");
      return req;
    });
  }

  async getFlussi(params = {}) {
    const url = `${this.baseUrl}/management/pdc/stats/flussi`;
    const response = await axios.get(url, { params });
    return response.data;
  }

  async getStatoPratiche(params = {}) {
    const url = `${this.baseUrl}/management/pdc/stats/stato-pratiche`;
    const response = await axios.get(url, { params });
    return response.data;
  }

  async getErrori(params = {}) {
    const url = `${this.baseUrl}/management/pdc/stats/errori`;
    const response = await axios.get(url, { params });
    return response.data;
  }

  /**
   * Lista POD richieste inviate (paginata).
   * @param {Object} params period, tipo, page, limit, q
   */
  async getPods(params = {}) {
    const url = `${this.baseUrl}/management/pdc/stats/pods`;
    const response = await axios.get(url, { params });
    return response.data;
  }

  async getPod(code) {
    const url = `${this.baseUrl}/management/pdc/stats/pod/${encodeURIComponent(code)}`;
    const response = await axios.get(url);
    return response.data;
  }
}
